export const PAYROLL_PANE_FILL_CLASS_NAME = "min-h-80 min-w-0 flex-1";

export const PAYROLL_GRID_CONTAINER_CLASS_NAME = PAYROLL_PANE_FILL_CLASS_NAME;
